import z from "zod";
import ZodSchemaUtil from "util/schema-helpers/ZodSchemaUtil";
import { AvatarSchema } from "rdx/modules/users/schemas/avatar";

export const LeadAddressSchema = z.object({
  street: z.string(),
  unit: z.string().nullable(),
  city: z.string(),
  state: z.string(),
  zip: z.string(),
  country: z.string().nullable(),
  status: ZodSchemaUtil.makeStringLiteralUnion(["unverified", "verified", "lookup_error", "locked"]),
  lat: z.union([z.number(), z.string()]).nullable(),
  long: z.union([z.number(), z.string()]).nullable(),
  googleMapsUrl: z.string().nullable(),
  geocodePrecision: z.string().nullable(),
  geocodeLat: z.union([z.number(), z.string()]).nullable(),
  geocodeLong: z.union([z.number(), z.string()]).nullable(),
});

export const LeadSchema = z.object({
  id: z.number(),
  firstName: z.string(),
  lastName: z.string(),
  fullName: z.string(),
  email: z.string(),
  phone: z.string(),
  averageBill: z.number().nullable(),
  category: z.string(),
  notes: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  locale: z.string(),
  kind: z.union([z.literal("consultant"), z.literal("ambassador"), z.literal("lead_generator")]),
  leadSource: z.string().nullable(),
  homeownerInterest: z.enum(["solar", "battery_only", "both"]).optional(),
  allowDuplicateAddress: z.boolean(),
  copilot: z.boolean(),
  siteId: z.number().nullable(),
  apiUri: z.string(),
  utilityBillUrl: z.string().nullable(),
  isAddressConfirmed: z.boolean(),
  owner: z.object({
    id: z.number(),
    fullName: z.string(),
    email: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    phone: z.string(),
    avatar: AvatarSchema,
  }),
  enterprise: z
    .object({
      id: z.number(),
      name: z.string(),
    })
    .optional(),
  address: LeadAddressSchema,
});
